import Breakdown from "./Breakdown";

const groups = [
  ["Group 1", "grades 1–4", [1, 2, 3, 4]],
  ["Group 2", "grades 5–6", [5, 6]],
  ["Group 3", "grades 7–9", [7, 8, 9]],
  ["Group 4", "grades 10–12", [10, 11, 12]],
];

export default function GroupsTable({ campers }) {
  const rows = groups.map(([name, note, grades]) => [
    name,
    (campers || []).filter((c) =>
      grades.some((g) => c.grade === `Grade ${g}`)
    ).length,
    note,
  ]);

  return <Breakdown title="Groups" rows={campers ? rows : []} />;
}
